import React from "react";
import {ApiResponse} from "@models/axios";
import {NavigationConfiguration, NavigationType} from "./navigation";
import {Platform} from "@models/index";
import {FormattedMessage} from 'react-intl';


export const enum HyperLinkMenuLocation {
  "NONE" = "none",
  "HEADER" = "header",
  "FOOTER" = "footer",
}

export const HyperLinkMenuLocationOptions = [{
  value: HyperLinkMenuLocation.HEADER,
    label: <FormattedMessage id="app.header" defaultMessage={`Header`}/>
}, {
  value: HyperLinkMenuLocation.FOOTER,
    label: <FormattedMessage id="app.footer" defaultMessage={`Footer`}/>
}];



export interface HyperLinkMenu extends ApiResponse {
  id: string,
  short_id: string,
  display_title: string
  location:HyperLinkMenuLocation
  configuration: NavigationConfiguration,
  platforms: Platform,
  order: number,
  is_active: boolean,
}


export interface HyperLinkMenusState {
  readonly loading: boolean
  readonly allIds: String[]
  readonly byId: object
  readonly count: number
}
